// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Label = require("../common/Components/Label.bs.js");
let Loader = require("../common/Components/Loader.bs.js");
let DateIcon = require("../common/Components/DateIcon.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let ShowingsUtils = require("../common/ShowingsUtils.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let DashboardCardComponents__Tw = require("./DashboardCardComponents__Tw.bs.js");
let UseShouldShowPropertyDetails = require("../common/Hooks/UseShouldShowPropertyDetails.bs.js");
let ChapterDashboardUpcomingShowings_query_graphql = require("../../__generated__/ChapterDashboardUpcomingShowings_query_graphql.bs.js");
let ChapterDashboardUpcomingShowingsSingleShowing_showing_graphql = require("../../__generated__/ChapterDashboardUpcomingShowingsSingleShowing_showing_graphql.bs.js");

function ChapterDashboard__UpcomingShowings$CardBodyContainer(props) {
  let __show_footer = props.show_footer;
  let show_footer = __show_footer !== undefined ? __show_footer : true;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      props.children,
      show_footer ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(DashboardCardComponents__Tw.Footer.make, {
            href: "/showings",
            linkText: "View all upcoming showings on TAN"
          }),
          className: "mt-8"
        }) : null
    ]
  });
}

let CardBodyContainer = {
  make: ChapterDashboard__UpcomingShowings$CardBodyContainer
};

function ChapterDashboard__UpcomingShowings$EmptyState(props) {
  return JsxRuntime.jsx(ChapterDashboard__UpcomingShowings$CardBodyContainer, {
    show_footer: true,
    children: JsxRuntime.jsx(DashboardCardComponents__Tw.EmptyStateContainer.make, {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: "There are no showings on TAN this week."
          }),
          JsxRuntime.jsx("p", {
            children: JsxRuntime.jsxs("span", {
              children: [
                JsxRuntime.jsx(ButtonsV5.Link.make, {
                  href: "/client_needs/new",
                  children: "Add your buyers"
                }),
                " so you won't miss new showings on properties that match."
              ]
            })
          })
        ],
        className: "text-left space-y-7"
      })
    })
  });
}

let EmptyState = {
  EmptyStateContainer: undefined,
  make: ChapterDashboard__UpcomingShowings$EmptyState
};

function ChapterDashboard__UpcomingShowings$LoadingState(props) {
  return JsxRuntime.jsx(ChapterDashboard__UpcomingShowings$CardBodyContainer, {
    show_footer: false,
    children: JsxRuntime.jsx(DashboardCardComponents__Tw.LoadingStateContainer.make, {
      children: JsxRuntime.jsx(Loader.make, {})
    })
  });
}

let LoadingState = {
  make: ChapterDashboard__UpcomingShowings$LoadingState
};

let convertFragment = ChapterDashboardUpcomingShowings_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ChapterDashboardUpcomingShowings_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ChapterDashboardUpcomingShowings_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ChapterDashboardUpcomingShowings_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ChapterDashboardUpcomingShowings_query_graphql.node, convertFragment, fRef);
}

let QueryFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = ChapterDashboardUpcomingShowingsSingleShowing_showing_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ChapterDashboardUpcomingShowingsSingleShowing_showing_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ChapterDashboardUpcomingShowingsSingleShowing_showing_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ChapterDashboardUpcomingShowingsSingleShowing_showing_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ChapterDashboardUpcomingShowingsSingleShowing_showing_graphql.node, convertFragment$1, fRef);
}

let ShowingFragment_showingTypeV5_decode = ChapterDashboardUpcomingShowingsSingleShowing_showing_graphql.Utils.showingTypeV5_decode;

let ShowingFragment_showingTypeV5_fromString = ChapterDashboardUpcomingShowingsSingleShowing_showing_graphql.Utils.showingTypeV5_fromString;

let ShowingFragment_visibilityReason_decode = ChapterDashboardUpcomingShowingsSingleShowing_showing_graphql.Utils.visibilityReason_decode;

let ShowingFragment_visibilityReason_fromString = ChapterDashboardUpcomingShowingsSingleShowing_showing_graphql.Utils.visibilityReason_fromString;

let ShowingFragment = {
  showingTypeV5_decode: ShowingFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ShowingFragment_showingTypeV5_fromString,
  visibilityReason_decode: ShowingFragment_visibilityReason_decode,
  visibilityReason_fromString: ShowingFragment_visibilityReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ChapterDashboard__UpcomingShowings$SingleShowing(props) {
  let showing = RescriptRelay_Fragment.useFragment(ChapterDashboardUpcomingShowingsSingleShowing_showing_graphql.node, convertFragment$1, props.showing);
  let match = showing.type_;
  let badgeText;
  if (match === "AGENTS_ONLY" || match === "TAN_ONLY" || match === "BUYERS_WELCOME") {
    switch (match) {
      case "AGENTS_ONLY" :
        badgeText = "Agents only";
        break;
      case "BUYERS_WELCOME" :
        badgeText = "Buyers welcome";
        break;
      case "TAN_ONLY" :
        badgeText = "TAN only";
        break;
    }
  } else {
    badgeText = undefined;
  }
  let shouldShowPropertyDetails = UseShouldShowPropertyDetails.use(showing.property.fragmentRefs);
  let match$1 = showing.property.propertyLocation;
  let tmp;
  let exit = 0;
  if (shouldShowPropertyDetails) {
    switch (match$1.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        tmp = JsxRuntime.jsx("div", {
          children: match$1.locationDisplay + ` (contact agent for address)`,
          className: "text-lg font-medium text-gray-800"
        });
        break;
      case "PropertyLocationWithVisibleAddress" :
        let locationDisplay = match$1.locationDisplay;
        let exit$1 = 0;
        let tmp$1 = match$1.visibilityRule;
        if (tmp$1 === "VISIBLE_TO_ACCOUNT_MEMBER" || tmp$1 === "VISIBLE_TO_TAN_STAFF" || tmp$1 === "VISIBLE_TO_ALL") {
          switch (tmp$1) {
            case "VISIBLE_TO_ACCOUNT_MEMBER" :
              tmp = JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                  children: locationDisplay + " (Hidden address)"
                }),
                className: "text-lg font-medium text-gray-800"
              });
              break;
            case "VISIBLE_TO_ALL" :
            case "VISIBLE_TO_TAN_STAFF" :
              exit$1 = 2;
              break;
          }
        } else {
          exit$1 = 2;
        }
        if (exit$1 === 2) {
          tmp = JsxRuntime.jsx("div", {
            children: match$1.address + ", " + locationDisplay,
            className: "text-lg font-medium text-gray-800"
          });
        }
        break;
      case "__unselected" :
        exit = 1;
        break;
    }
  } else {
    let exit$2 = 0;
    let locationDisplay$1;
    switch (match$1.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        locationDisplay$1 = match$1.locationDisplay;
        exit$2 = 2;
        break;
      case "PropertyLocationWithVisibleAddress" :
        locationDisplay$1 = match$1.locationDisplay;
        exit$2 = 2;
        break;
      case "__unselected" :
        exit = 1;
        break;
    }
    if (exit$2 === 2) {
      tmp = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: locationDisplay$1
        }),
        className: "text-lg font-medium text-gray-800"
      });
    }
  }
  if (exit === 1) {
    tmp = UnselectedUnionMemberError.raise(`Unselected address type ` + match$1._0);
  }
  return JsxRuntime.jsx(ButtonsV5.Link.make, {
    href: "/properties/" + (showing.property.id + "#showings"),
    className: "text-gray-900",
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(DateIcon.FromPlainDate.make, {
              date: showing.startDateV2.toPlainDate()
            })
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  tmp,
                  JsxRuntime.jsx("div", {
                    children: ShowingsUtils.formatShowingTimes(showing.startDateV2, showing.endDateV2),
                    className: "text-md text-gray-500 mt-1"
                  })
                ]
              }),
              badgeText !== undefined ? JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(Label.Neutral.make, {
                    text: badgeText
                  }),
                  className: ""
                }) : null
            ],
            className: "flex flex-col-reverse gap-2 md:flex-row md:justify-between md:flex-1 items-baseline"
          })
        ],
        className: "flex flex-row space-x-4 relative"
      }),
      className: "bg-white border border-gray-200 rounded-md p-3"
    })
  });
}

let SingleShowing = {
  ShowingFragment: ShowingFragment,
  make: ChapterDashboard__UpcomingShowings$SingleShowing
};

function ChapterDashboard__UpcomingShowings(props) {
  let query = RescriptRelay_Fragment.useFragment(ChapterDashboardUpcomingShowings_query_graphql.node, convertFragment, props.query);
  let showings = Stdlib_Array.filterMap(Stdlib_Option.getOr(Stdlib_Option.map(query.upcomingShowingsV5, v => Stdlib_Option.getOr(v.edges, [])), []), v => {
    if (v !== undefined) {
      return v.node;
    }
  });
  let weekShowingsCount = Stdlib_Option.getOr(Stdlib_Option.flatMap(query.upcomingShowingsCountV5, v => v.total), 0);
  if (showings.length !== 0) {
    return JsxRuntime.jsx(ChapterDashboard__UpcomingShowings$CardBodyContainer, {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: weekShowingsCount === 1 ? "There is 1 showing this week" : "There are " + (weekShowingsCount.toString() + " showings this week"),
              className: "text-gray-600"
            }),
            className: "mb-8"
          }),
          JsxRuntime.jsx("ul", {
            children: showings.map(showing => JsxRuntime.jsx("li", {
              children: JsxRuntime.jsx(ChapterDashboard__UpcomingShowings$SingleShowing, {
                showing: showing.fragmentRefs
              })
            }, showing.id)),
            className: "space-y-4"
          })
        ],
        className: "grow"
      })
    });
  } else {
    return JsxRuntime.jsx(ChapterDashboard__UpcomingShowings$EmptyState, {});
  }
}

let DashboardCardComponents;

let make = ChapterDashboard__UpcomingShowings;

exports.DashboardCardComponents = DashboardCardComponents;
exports.CardBodyContainer = CardBodyContainer;
exports.EmptyState = EmptyState;
exports.LoadingState = LoadingState;
exports.QueryFragment = QueryFragment;
exports.SingleShowing = SingleShowing;
exports.make = make;
/* Label Not a pure module */
